import {FRAME_CHARGER_SERIAL} from '../../consts/scp/scpFrames';
import {selectIsFirmwareStarted} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import log from '../logger/log';
import pairingService from '../pairingService';
import connectivityService from './connectivityService';
import framesProcessingService from './framesProcessingService';

// This scheduler is used to ping device until first frames come form CM
// it prevents the device from sleeping

const PING_CHARGER_SCHEDULER_INTERVAL_MS = 3000;

let pingSchedulerInterval;

const startPing = () => {
    const isUsb = connectivityService.isUsb();

    if (pingSchedulerInterval || isUsb) return;

    const isFwuInProgress = selectIsFirmwareStarted(getState());

    // Do not ping device if FWU is in progress
    // Steps to reproduce:
    //  1. Start FWU of the charger via BLE(without inserted holder)
    //  2. Insert holder
    if (isFwuInProgress) return;

    log.debug('devicePreSyncPingScheduler: startPing');

    pingSchedulerInterval = setInterval(() => {
        const isDeviceConnected = pairingService.isDeviceConnected();

        if (!isDeviceConnected) {
            stopPing();
            return;
        }

        framesProcessingService.processFrames({
            frames: [FRAME_CHARGER_SERIAL],
            retryCount: 0,
        });
    }, PING_CHARGER_SCHEDULER_INTERVAL_MS);
};

const stopPing = () => {
    if (!pingSchedulerInterval) return;
    clearInterval(pingSchedulerInterval);
    pingSchedulerInterval = null;

    log.debug('devicePreSyncPingScheduler: stopPing');
};

export default {
    stopPing,
    startPing,
};
